import { render } from "./JobBodyComponent.vue?vue&type=template&id=72f1fb09"
import script from "./JobBodyComponent.vue?vue&type=script&lang=js"
export * from "./JobBodyComponent.vue?vue&type=script&lang=js"

import "./JobBodyComponent.vue?vue&type=style&index=0&id=72f1fb09&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__